import { render, staticRenderFns } from "./GenericPaginationSubHeader.vue?vue&type=template&id=24d097d6&"
import script from "./GenericPaginationSubHeader.vue?vue&type=script&lang=js&"
export * from "./GenericPaginationSubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports